export default __webpack_public_path__ + "_/react/assets/images/iPhoneX_mobile.png";